module.exports = __webpack_public_path__ + "static/media/logo.26fdd735.svg";